import React from "react";
import { Icon } from "../core/Icon.jsx";

// Nur die Fassung mit Fach hebt sich hervor: Der Rahmen der Hülle geht unter
// dem Zeiger auf --line-i. Das steht als :hover-Regel an .erp-field in tokens/base.css
// und nicht mehr als Kennzeichen im Zustand — das blieb hängen, wenn das mouseleave
// ausfiel, und das Feld sah dann angefasst aus, ohne es zu sein.
//
// Das Feld hat zwei Fächer, und beide öffnen dieselbe Hülle: `iconLeft` legt eine
// Glyphe vor den Text, `action` hängt einen Knopf dahinter. Sie gehen zusammen —
// Kennwort mit `lock` links und `eye`/`eye-off` rechts ist der gewöhnliche Fall.
// Ohne beides bleibt der Baustein das nackte <input>, das er immer war; er bekommt
// dann keine Hülle, und nichts an seinem Bild ändert sich.
//
// `id` und `name` gehen unverändert an das <input>, auch in dieser Fassung: Das `htmlFor`
// einer FormRow muss auf das Feld zeigen und nicht auf die Hülle. Beide ohne Vorgabe —
// ein erzeugtes id wäre ein zweites, mit dem die Maske nicht rechnet.
export function TextField({ id, name, value, placeholder, type = "text", onChange, iconLeft, action, actionTip, onAction, disabled = false, mono = false, align = "left", style = {} }) {
  const framed = Boolean(iconLeft || action);
  const input = (
    <input id={id} name={name} type={type} value={value} placeholder={placeholder} disabled={disabled}
      onChange={onChange ? (e) => onChange(e.target.value) : undefined}
      style={{
        flex: 1, minWidth: 0, width: "100%", height: framed ? "100%" : "var(--h-field)",
        background: framed ? "transparent" : disabled ? "var(--bg-field-off)" : "var(--bg-field)",
        border: framed ? "none" : "1px solid var(--line-d)", borderRadius: framed ? 0 : "var(--r-field)",
        outline: "none", padding: "0 8px",
        color: disabled ? "var(--fg-9)" : "var(--fg-1)",
        // In der Hülle erbt die Schriftgröße: Sie ist dort ein Maß des Feldes wie Höhe,
        // Fläche und Radius, und der Aufrufer setzt sie mit ihnen zusammen an einer
        // Stelle. Die Hülle gibt --type-value-size vor, also zeichnet ein Feld ohne
        // eigene Angabe wie zuvor.
        fontFamily: mono ? "var(--font-mono)" : "inherit", fontSize: framed ? "inherit" : "var(--type-value-size)", textAlign: align,
      }} />
  );
  if (!framed) return React.cloneElement(input, { style: { ...input.props.style, ...style } });
  return (
    <span className="erp-field" style={{ display: "flex", alignItems: "stretch", height: "var(--h-field)", background: "var(--bg-field)", border: "1px solid var(--field-hot-border, var(--line-d))", borderRadius: "var(--r-field)", overflow: "hidden", fontSize: "var(--type-value-size)", ...style }}>
      {/* Das linke Fach ist kein Knopf: keine Fläche, keine Trennlinie, nur die Glyphe in
          --ico-c. Sein Abstand ist fest und nicht die Feldhöhe — so steht die Glyphe im
          38 px hohen Anmeldefeld an derselben Stelle wie im 26 px hohen Feld der Maske. */}
      {iconLeft ? <span style={{ display: "flex", alignItems: "center", flex: "none", paddingLeft: 10, color: "var(--ico-c)" }}><Icon name={iconLeft} size={13} /></span> : null}
      {input}
      {action ? (
        <button title={actionTip} onClick={onAction} style={{
          display: "flex", alignItems: "center", justifyContent: "center", width: "var(--h-field)", flex: "none",
          background: "var(--bg-chip)", border: "none", borderLeft: "1px solid var(--line-d)",
          color: "var(--fg-5)", cursor: "pointer",
        }}><Icon name={action} size={13} /></button>
      ) : null}
    </span>
  );
}
